export const polisTandil = {
    cuitPoli: ['33691439009','30522749210','30691485303','30707109102','30661614591','30661571353','27355624450'],
    esTandil: (cuit) => {
        return polisTandil.cuitPoli.some(c => c == cuit);
    }
};